function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { CheckBox } from "../../../native";
// import { schemaRequiresTrueValue } from '../../utils'
import { useFormContext } from "../FormContext";

const CheckboxWidget = props => {
  const {
    value,
    disabled,
    readonly,
    onChange,
    formContext //  label,
    //  schema,

  } = props;
  const {
    mapping
  } = useFormContext(formContext); // const required = schemaRequiresTrueValue(schema);

  const checked = !!value;
  return /*#__PURE__*/React.createElement(CheckBox, _extends({}, mapping.checkbox, {
    style: [mapping.checkbox.style],
    checked: !!value,
    onChange: onChange,
    disabled: disabled || readonly
  }), checked ? 'true' : 'false');
}; // {/* {schema.title ?? label} */}


export default CheckboxWidget;